import logo from '../../assets/image/logo.png';

function FooterSection() {
  return (
    <>
      {/* Contact Section */}
      <section className="relative py-20 bg-black overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gradient-to-b from-amber-500/5 to-transparent rounded-full blur-[100px]"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20 text-amber-400 px-5 py-2 rounded-full text-sm font-medium mb-6">
              <span className="text-lg">📞</span>
              Get In Touch
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4">
              For Any Kind of Queries
              <span className="text-amber-400"> Kindly Contact</span>
            </h2>
          </div>

          {/* Contact Card */}
          <div className="relative max-w-xl mx-auto group">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/30 to-orange-500/30 rounded-3xl blur-xl opacity-50 group-hover:opacity-70 transition-opacity"></div>
            
            <div className="relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 md:p-10 border border-gray-700 text-center overflow-hidden">
              {/* Shimmer */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
              
              {/* Avatar */}
              <div className="relative inline-block mb-6">
                <div className="absolute -inset-2 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full blur-md opacity-50"></div>
                <div className="relative w-28 h-28 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center text-black text-4xl font-black shadow-xl">
                  SK
                </div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-2">Mrs. Sanjeet Kaur</h3>
              <p className="text-gray-400 mb-6">Customer Support Team</p>

              {/* Phone Button */}
              <a
                href="tel:918920633120"
                className="group/phone inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-8 py-4 rounded-2xl font-bold text-xl shadow-lg shadow-green-500/25 hover:shadow-green-500/50 transition-all hover:scale-105 mb-4"
              >
                <span className="relative">
                  <span className="absolute inset-0 bg-white/30 rounded-full blur animate-ping"></span>
                  <span className="relative text-2xl">📱</span>
                </span>
                8920633120
              </a>

              <p className="text-gray-500 text-sm flex items-center justify-center gap-2">
                <span>📅</span>
                10:00 AM Till 7:00 PM • WhatsApp Call Only
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-gray-900 border-t border-gray-800 overflow-hidden">
        {/* Top Gradient Line */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-500 via-orange-500 to-red-500"></div>

        {/* Background */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(251,191,36,0.05),transparent_50%)]"></div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Main Footer Content */}
          <div className="text-center">
            {/* Logo */}
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="w-20 h-20 bg-white rounded-2xl p-2 shadow-lg shadow-amber-500/25">
                <img 
                  src={logo} 
                  alt="Rushneek Singh Logo" 
                  className="w-full h-full rounded-xl object-contain"
                />
              </div>
              <div className="text-left">
                <span className="text-2xl font-black text-white block leading-tight">Rushneek Singh</span>
                <span className="text-amber-400 text-sm font-medium">India's No.1 B2B Payment Recovery Coach</span>
              </div>
            </div>

            {/* Description */}
            <p className="text-gray-400 max-w-md mx-auto mb-8">
              India's No.1 B2B Payment Recovery Coach helping business owners recover stuck payments for over 04 years.
            </p>

            {/* Social Links */}
            <div className="flex justify-center gap-4 mb-8">
              {[
                { icon: "📘", label: "Facebook" },
                { icon: "📸", label: "Instagram" },
                { icon: "🎥", label: "YouTube" },
                { icon: "💼", label: "LinkedIn" }
              ].map((social, i) => (
                <button
                  key={i}
                  className="w-12 h-12 bg-gray-800 hover:bg-gray-700 rounded-xl flex items-center justify-center text-xl transition-all hover:scale-110 hover:-translate-y-1"
                  aria-label={social.label}
                >
                  {social.icon}
                </button>
              ))}
            </div>

            {/* Divider */}
            <div className="w-32 h-0.5 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto mb-8"></div>

            {/* Copyright */}
            <p className="text-gray-500 text-sm mb-2">
              © {new Date().getFullYear()} Rushneek Singh. All Rights Reserved.
            </p>
            
            <p className="text-gray-600 text-sm flex items-center justify-center gap-2">
              Made with <span className="text-red-500 animate-pulse">❤️</span> in India
            </p>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-4 mt-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-amber-400 transition-colors">Privacy Policy</a>
              <span className="text-gray-700">•</span>
              <a href="#" className="text-gray-500 hover:text-amber-400 transition-colors">Terms of Service</a>
              <span className="text-gray-700">•</span>
              <a href="#" className="text-gray-500 hover:text-amber-400 transition-colors">Refund Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterSection;
